/**
 * 3CX Web Client Integration (Alternative to REST API)
 * This uses the 3CX web client URL scheme for click-to-dial
 * No admin credentials needed - just the 3CX web client URL
 */

class ThreeCXWebClient {
  constructor() {
    // Your 3CX web client URL
    this.webClientUrl = process.env.REACT_APP_3CX_WEB_CLIENT_URL || 'https://1726.3cx.cloud';
  }

  /**
   * Initiate a call by opening the 3CX web client.
   * V20 dropped the deep-link URL scheme, so we copy the number to clipboard
   * and open the dialer — user pastes once and presses call.
   * @param {string} phoneNumber - The phone number to call
   */
  async makeCall(phoneNumber) {
    try {
      let formattedNumber = phoneNumber;
      if (!formattedNumber.startsWith('+')) {
        formattedNumber = `+260${formattedNumber.replace(/^0+/, '')}`;
      }

      let copied = false;
      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(formattedNumber);
          copied = true;
        } catch (e) {
          console.warn('Clipboard write failed:', e);
        }
      }

      window.open(this.webClientUrl, '_blank', 'width=480,height=720');

      return {
        success: true,
        method: '3CX Web Client',
        number: formattedNumber,
        copied,
        message: copied
          ? `Number ${formattedNumber} copied — paste it into the 3CX dialer.`
          : `3CX web client opened. Dial ${formattedNumber}.`,
      };
    } catch (error) {
      console.error('3CX web client call failed:', error);
      return {
        success: false,
        error: error.message,
      };
    }
  }

  /**
   * Check if 3CX web client URL is configured
   */
  isConfigured() {
    return !!this.webClientUrl;
  }
}

// Export singleton instance
const threeCXWebClient = new ThreeCXWebClient();
export default threeCXWebClient;
